import React from 'react';
import './LoveAnalyticsSection.css';

export default function LoveAnalyticsSection() {
  return (
    <section className="love">
      <h2 className="love-title">Placeholder header line...</h2>

      <div className="love-grid">
        {/* Column 1 */}
        <div className="love-col">
          <TweetCard
            user="User A"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
          <TweetCard
            user="User B"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
          <TweetCard
            user="User C"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
        </div>

        {/* Column 2 */}
        <div className="love-col">
          <TweetCard
            user="User D"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
          <ImageCard
            user="User E"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
        </div>

        {/* Column 3 */}
        <div className="love-col">
          <ImageCard
            user="User F"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
          <TweetCard
            user="User G"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
          />
        </div>
      </div>

      <a className="love-link" href="#">See more placeholder →</a>
    </section>
  );
}

/* ---------- Cards ---------- */

function TweetCard({ user, text }) {
  return (
    <div className="tweet-card">
      <div className="tweet-header">
        <div className="avatar" />
        <span className="username">{user}</span>
        <span className="twitter-icon">𝕏</span>
      </div>
      <p className="tweet-text">{text}</p>
    </div>
  );
}

function ImageCard({ user, text }) {
  return (
    <div className="tweet-card">
      <div className="tweet-header">
        <div className="avatar" />
        <span className="username">{user}</span>
        <span className="twitter-icon">𝕏</span>
      </div>
      <p className="tweet-text">{text}</p>
      <div className="tweet-image" />
    </div>
  );
}
